import RecommendedTripsList from './RecommendedTripsList';

export default RecommendedTripsList;
